import React, { ReactNode, useState } from 'react';
import styles from './card-with-overlay.module.scss';
import { Triangle } from '../triangle/triangle';

interface ICardWithOverlayProps {
  title: string;
  children: ReactNode;
}

export const CardWithOverlay: React.FC<ICardWithOverlayProps> = ({
  title,
  children,
}) => {
  const [isClosed, setIsClosed] = useState(false);
  return (
    <div
      className={`${styles.card__container} ${isClosed ? styles.card__closed_gap : ''}`}
    >
      <div
        onClick={() => setIsClosed((prev) => !prev)}
        className={styles.card__title}
      >
        <div className={styles.title__text}>{title}</div>
        <div className={styles.title__triangle}>
          <Triangle isRotated={!isClosed}></Triangle>
        </div>
      </div>
      <div
        className={`${styles.card__children} ${isClosed ? styles.children__closed : ''}`}
      >
        {children}
      </div>
    </div>
  );
};
